import axios from "axios";

const SETTINGS_URL =
  `${process.env.REACT_APP_API_URL}/api/caixa` ||
  "http://localhost:3001/api/caixa";

export async function getCaixa(token) {
  const headers = {
    authorization: token,
  };
  const response = await axios.get(SETTINGS_URL, { headers });
  return response.data;
}

